import {DocumentNode, gql} from "@apollo/client";

export const NOTIFICATION_SETTING_INFO_FRAGMENT: DocumentNode = gql(`
    fragment NotificationSetting on NotificationSettingResponse {
      balance
      email
    }
`);
